export default __webpack_public_path__ + "static/media/ahmaudArbery.cb4643dd.png";